module.exports = __webpack_public_path__ + "assets/media/7.9bcd19ca.wav";